import { Box, Container, Grid } from '@mui/material';
import React from 'react';

// import styles
import useStyles from '../../assets/styles/components/footerLogin';

// import icon svg
import { ReactComponent as IconHamburguer } from '../../assets/images/svg/login/hamburguer.svg';
import { ReactComponent as IconRosquinha } from '../../assets/images/svg/login/rosquinha.svg';
import { ReactComponent as IconSushi } from '../../assets/images/svg/login/sushi.svg';

const FooterLogin: React.FC = () => {
  const classeStyle = useStyles();
  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Box sx={{ flexGrow: 1 }}>
        <Grid textAlign="center" alignItems="center" container spacing={3}>
          <Grid item xs>
            <IconRosquinha className={classeStyle.iconRoquinha} />
          </Grid>
          <Grid item xs>
            <IconHamburguer className={classeStyle.iconHumburguer} />
          </Grid>
          <Grid item xs>
            <IconSushi className={classeStyle.iconSushi} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
export default FooterLogin;
